<script>
import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin],
	components: {
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			datos: {
				notas: ''
			},
			config: {
				events: {
					initialized: function () {
						console.log('initialized')
					}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},
	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		calcBase(datos, index) {
			
			let item = datos[index]
			let baseItem = datos[item.base]
			
			if(baseItem) {
				if((baseItem.monto * 1)) {
					return ((Number(item.monto)/Number(baseItem.monto)) *  100).toFixed(2) || 0
				}
				return 0
			}
			return 0
		},
	}

}
</script>

<template>
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
	
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="">Resumen Ejecutivo</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
			
		</div>
		<div id="accordion_re" class="pf-accordion  pb-3">
			<div class="card">
				<div class="card-header p-1" id="re_h_1">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#re_1" aria-expanded="true" aria-controls="re_1">
						Datos básicos
					</button>
				</div>

				<div id="re_1" class="collapse show" aria-labelledby="re_h_1" data-parent="#accordion_re">
					<div class="d-flex flex-wrap">
						<div class="col-12 col-md-6 col-lg-5">
							<label class="pf-control">
								<span class="pf-control__label">País Cabecera</span>
								<span class="">{{cliente.datos.pais_cabecera}}</span>
							</label>	
						</div>	

						<div class="col-12"></div>
							
						<div class="col-12 col-md-6 col-lg-5">
							<label class="pf-control">
								<span class="pf-control__label">Actividad pricipal/Calve Banxico</span>
								<span class="">{{cliente.datos.actividad_principal}}</span>
							</label>	
						</div>
						<div class="col-12"></div>
						
						<div class="col-6">

							<div>
								<table class="table pf-table-th-gray table-bordered" style="font-size: 0.8rem">
									<tr>
										<th rowspan="3">
											Rating BBVA
										</th>
										<td>
											<div class="d-flex">
												<div class="col-6">Avance anual</div>
												<div class="col-6">
													<select class="pf-control__input">
														<option value="">BB2</option>
													</select>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="d-flex">
												<div class="col-6">Actual</div>
												<div class="col-6">
													<select class="pf-control__input" disabled>
														<option value="">BB2</option>
													</select>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="d-flex">
												<div class="col-6">Previo</div>
												<div class="col-6">
													<select class="pf-control__input" disabled>
														<option value="">B + 1</option>
													</select>
												</div>
											</div>
										</td>
									</tr>
								</table>

							</div>
						</div>
						<div class="col-6">
							<div>
								<table class="table pf-table-th-gray table-bordered">
									<tr>
										<th rowspan="3">
											Rating Externo
										</th>
										<td>
											<div class="d-flex">
												<div class="col-3">S&P</div>
												<div class="col-4">
													<select class="pf-control__input">
														<option value="">N/A</option>
													</select>
												</div>
												<div class="col-5">
													<select class="pf-control__input">
														<option value="">--Seleccione--</option>
													</select>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="d-flex">
												<div class="col-3">Moody's</div>
												<div class="col-4">
													<select class="pf-control__input">
														<option value="">N/A</option>
													</select>
												</div>
												<div class="col-5">
													<select class="pf-control__input">
														<option value="">--Seleccione--</option>
													</select>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="d-flex">
												<div class="col-3">Fitch</div>
												<div class="col-4">
													<select class="pf-control__input">
														<option value="">N/A</option>
													</select>
												</div>
												<div class="col-5">
													<select class="pf-control__input">
														<option value="">--Seleccione--</option>
													</select>
												</div>
											</div>
											
										</td>
									</tr>
								</table>

							</div>
						</div>


			
						<div class="col-12 mx-auto">
							<label class="pf-control d-flex">
								<span class="pf-control__label">INDENTIFICACIÓN</span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.datos_basicos.datos.notas"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="re_h_2">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#re_2" aria-expanded="true" aria-controls="re_2">
						Síntesis económico-financiera
					</button>
				</div>

				<div id="re_2" class="collapse" aria-labelledby="re_h_2" data-parent="#accordion_re">
					<h5 class="text-primary px-3">Balance</h5>
					<div class="d-flex flex-wrap pt-5" v-if="datos.financial_risk.datos.estructura.length">
						<div class="col-12 col-lg-3">
							<label class="pf-control">
								<span class="pf-control__label">Datos en</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" :value="datos.financial_risk.datos.estructura[0].datos.balance_datos_en" disabled>
									<option value=""></option>
									<option value="Miles">Miles</option>
									<option value="Millones">Millones</option>
								</select>
							</label>	
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">
								<span class="pf-control__label">Divisa</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" :value="datos.financial_risk.datos.estructura[0].datos.balance_divisa" disabled>
									<option value=""></option>
									<option value="Euros">Euros</option>
									<option value="Pesos Mexicanos">Pesos Mexicanos</option>
									<option value="Dólares">Dólares</option>
								</select>
							</label>	
						</div>
						<div class="col-6 text-right">
							<a href="#" style="color: black; text-decoration:underline;font-size:0.8rem;">Global Risk Analyst (RA)</a>
						</div>

						<div v-if="datos.financial_risk.datos.estructura[0].datos.informes.length" class="col-12 mt-5">
							<table class="table pf-table-th-gray" v-if="datos.financial_risk.datos.estructura[0].datos.informes[0].balance">
								<tr>
									<th>

									</th>
									<template  v-for="(reporte, index) in datos.financial_risk.datos.estructura[0].datos.informes">
										<th :key="`reporte_${index}`">
											{{reporte.fecha}}
										</th>
										<th :key="`reporte_p_${index}`">

											%
										</th>
									</template>
								</tr>
								<tr>
									<td>
										<span class="text-primary">ACTIVOS</span>
									</td>
								</tr>
								<tr v-for="(item, index) in datos.financial_risk.datos.estructura[0].datos.informes[0].balance.activo" :key="`reporte_r_${index}`">
									<td class="py-1">
										{{item.titulo}}
									</td>
									<template  v-for="(reporte, index2) in datos.financial_risk.datos.estructura[0].datos.informes">
										<td class="py-1 text-right" :key="`reporte_${index2}`" style="color: #ccc">
											{{(datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.activo[index] ? datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.activo[index].monto : '') | numeral('0,0')}}
										</td>
										<td class="py-1 text-right" :key="`reporte_p_${index2}`" style="color: #ccc">
											{{datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.activo[index] ? datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.activo[index].porcentaje : ''}}
										</td>
									</template>
								</tr>
								<tr>
									<td>
										<span class="text-primary">PASIVOS</span>
									</td>
								</tr>
								<tr v-for="(item, index) in datos.financial_risk.datos.estructura[0].datos.informes[0].balance.pasivo" :key="`reporte__p_r_${index}`">
									<td class="py-1">
										{{item.titulo}}
									</td>
									<template  v-for="(reporte, index2) in datos.financial_risk.datos.estructura[0].datos.informes">
										<td class="py-1 text-right" :key="`reporte_p_${index2}`" style="color: #ccc">
											{{(datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.pasivo[index] ? datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.pasivo[index].monto : '') | numeral('0,0')}}
										</td>
										<td class="py-1 text-right" :key="`reporte_p_p_${index2}`" style="color: #ccc">
											{{datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.pasivo[index] ? datos.financial_risk.datos.estructura[0].datos.informes[index2].balance.pasivo[index].porcentaje : ''}}
										</td>
									</template>
								</tr>
							</table>
						</div>
					</div>
					<h5 class="text-primary px-3 mt-5">Cuenta de resultados</h5>
					<div class="d-flex flex-wrap" v-if="datos.financial_risk.datos.estructura.length">
						<div class="col-12 col-lg-3">
							<label class="pf-control">
								<span class="pf-control__label">Datos en</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" :value="datos.financial_risk.datos.estructura[0].datos.cuenta_resultados_datos_en" disabled>
									<option value=""></option>
									<option value="Miles">Miles</option>
									<option value="Millones">Millones</option>
								</select>
							</label>	
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">
								<span class="pf-control__label">Divisa</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" :value="datos.financial_risk.datos.estructura[0].datos.cuenta_resultados_divisa" disabled>
									<option value=""></option>
									<option value="Euros">Euros</option>
									<option value="Pesos Mexicanos">Pesos Mexicanos</option>
									<option value="Dólares">Dólares</option>
								</select>
							</label>	
						</div>
		

						<div v-if="datos.financial_risk.datos.estructura[0].datos.informes.length" class="col-12 mt-5">
							<table class="table pf-table-th-gray" v-if="datos.financial_risk.datos.estructura[0].datos.informes[0].cuenta_resultados">
								<tr>
									<th>

									</th>
									<template  v-for="(reporte, index) in client.datos.informes">
										<th :key="`reporte_${index}`">
											{{reporte.fecha}}
										</th>
										<th class="text-right" :key="`reporte_p_${index}`">

											%
										</th>
									</template>
								</tr>
									<tr v-for="(item, index) in datos.financial_risk.datos.estructura[0].datos.informes[0].cuenta_resultados" :key="`reporte_r_cr_${index}`">
										<td class="py-1">
											{{item.titulo}}
										</td>
										<template  v-for="(reporte, index2) in datos.financial_risk.datos.estructura[0].datos.informes">
											<td  class="py-1 text-right" :key="`reporte_cr_${index2}`" style="color: #ccc">
												<span v-if="client.tipo != 'Filial'">
													{{datos.financial_risk.datos.estructura[0].datos.informes[index2].cuenta_resultados[index].monto | numeral('0,0.00')}}
												</span>
												<input v-else type="text" class="text-right" v-model="datos.financial_risk.datos.estructura[0].datos.informes[index2].cuenta_resultados[index].monto">
											</td>
											<td class="py-1 text-right" :key="`reporte_p_cr_${index2}`" style="color: #ccc">
												<!-- {{datos.financial_risk.datos.estructura[0].datos.informes[index2].cuenta_resultados[index].porcentaje}} -->
												{{calcBase(datos.financial_risk.datos.estructura[0].datos.informes[index2].cuenta_resultados, index)}}%
											</td>
										</template>
									</tr>
							</table>
						</div>
						<div v-if="client.hasOwnProperty('extra')" class="col-12">
							<table class="table pf-table-th-gray">
								<tr>
									<th></th>
									<th></th>
									<th v-for="(ano, index) in client.extra[0].anos" :key="`extra_${index}`">
										{{ano}}
									</th>
								</tr>
								<tr v-for="(item, index) in client.extra" :key="`row_extra_${index}`">
									<td style="max-width: 300px">{{item.titulo}}</td>
									<td class="small" style="max-width: 200px">{{item.formula}}</td>
									<td v-for="(d,index2) in client.extra[index].datos" :key="`row_datos_${index2}`">
										{{d}}
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="re_h_3">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#re_3" aria-expanded="true" aria-controls="re_3">
						Detalle de posiciones actuales, Nuevos limites y políticas de riesgos grupo
					</button>
				</div>

				<div id="re_3" class="collapse" aria-labelledby="re_h_3" data-parent="#accordion_re">
					<div class="d-flex flex-wrap" v-if="datos.politicas.datos.estructura.length">
						<div class="col-12 col-lg-3 px-4">
							<label class="pf-control">
								<span class="pf-control__label">Política (*)</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" v-model="datos.politicas.datos.estructura[0].datos.politica">
									<option value="">--Seleccione--</option>
									<option value="MANTENER">MANTENER</option>
									<option value="EXTINGUIR">EXTINGUIR</option>
									<option value="MANTENER">MANTENER</option>
									<option value="REDUCIR">REDUCIR</option>
								</select>
							</label>	
						</div>
						<div class="col-12 col-lg-3"></div>
						<div class="col-12 col-lg-3"></div>
						<div class="col-12 col-lg-3 px-4">
							<label class="pf-control">
								<span class="pf-control__label">F. Vencimiento (*)</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<input class="pf-control__input pf-control--block px-1"  type="date" style="max-width: 150px" name="" v-model="datos.politicas.datos.estructura[0].datos.fecha_vencimiento">
							</label>	
						</div>
						<div class="col-12 col-lg-3 px-4">
							<label class="pf-control">
								<span class="pf-control__label">Datos en (*)</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" v-model="datos.politicas.datos.estructura[0].datos.politicas_datos_en">
									<option value="">--Seleccione--</option>
									<option value="Unidades">Unidades</option>
									<option value="Miles">Miles</option>
									<option value="Millones">Millones</option>
								</select>
							</label>	
						</div>
						<div class="col-12 col-lg-3 px-4">
							<label class="pf-control">
								<span class="pf-control__label">Divisa en (*)</span>
								<!-- TODO listas desde caratula de los cobos select -->
								<select class="pf-control__input pf-control--block" name="" v-model="datos.politicas.datos.estructura[0].datos.politicas_divisa">
									<option value="">--Seleccione--</option>
									<option value="Euros">Euros</option>
									<option value="Pesos Mexicanos">Pesos Mexicanos</option>
									<option value="Dólares">Dólares</option>
									<option value="Yuan">Yuan</option>
								</select>
							</label>	
						</div>
						<div class="col-12 col-lg-6"></div>
						<div class="col-12 col-lg-6 px-4">
							<h5 style="font-weight: 700; font-size: 0.9rem">(*) Se deberá rellenar al menos una fila en la parrilla</h5>
						</div>

						<div class="col-12 pt-5">
							<div style="overflow-x: auto;">
								<table class="table pf-table-th-gray table-bordered">
									<tbody>
										<tr>
											<th class="text-center py-3"></th>
											<th class="text-center py-3">LÍMITE ANTERIOR</th>
											<th class="text-center py-3">LÍMITE ACTUAL</th>
											<th class="text-center py-3">DISPUESTO</th>
											<th class="text-center py-3">LÍMITE NUEVO</th>
											<th class="text-center py-3">NOTAS</th>
										</tr>
										<tr v-for="(item, index) in datos.politicas.datos.estructura[0].datos.politicas_datos" :key="`politica_item_${index}`">
											<td style="width: 250px">
												<div class="d-flex align-items-center">
													<button class="btn btn-light p-1 text-primary" @click="removeShareholder(index)">
														<span class="icon-trash"></span>
													</button>
													<span class="ml-2" :class="{'font-weight-bold': item.negritas}" style="font-size: 0.9rem">{{item.nombre}}</span>
												</div>
											</td>
											<td>
												<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_anterior" disabled>
											</td>
											<td>
												<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_actual" disabled>
											</td>
											<td>
												<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.dispuesto" disabled>
											</td>
											<td>
												<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_nuevo" disabled>
											</td>
											<td>
												<input class="pf-control__input pf-control--block text-center" type="text" v-model="item.notas" disabled>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div>
								<p>(*) Campos obligatorios para realizar la propuesta</p>
								<p>(**) Los importes residuales que excedan de dicho marco computarán como marco emisor, si existieran límites aprobados disponibles.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>